// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_ResultTagging.scss
// module id = 668
// module chunks = 64 88